import { errorMessages } from "../../../assets/config";
import { qtyProxy } from "../../../..";
import { createSvgFromText, getPostBrandingDetails, getShoCartRedirectUrl, getSVGCords, setLoader } from "../../../helpers/helper";
import { DownloadImage } from "./downloadCanvas";
import { sendDataToOdoo } from "../../../helpers/apiHelper";
let isColorsValid;

const handleAddToCartApiCall = (odooUrl,finalProductData,haveDataInAllPosition,isColorsValid) => {
  if(!haveDataInAllPosition){
    alert(errorMessages.POSITION_EMPTY);
    return;
  }

  if(!isColorsValid){
      alert(`Please reduce the colors in logo`);
      return;
  }
  
  setLoader(true);
  sendDataToOdoo(getPostBrandingDetails(odooUrl), { data: finalProductData })
    .then((result) => {
      setLoader(false);
      if (result?.result?.status === "success") {
        window.location.replace(getShoCartRedirectUrl(odooUrl));
        return;
      }
      qtyProxy['isFormSubmiting'] = false;
    })
    .catch(() => {
      setLoader(false);
      qtyProxy['isFormSubmiting'] = false;
      alert(errorMessages.SERVER_ERROR);
    });
};

const colorValidationHandler = (imgId,selected_color_count,is_single_color_selected) => {
  const totalColor: number = qtyProxy?.logoList?.find((logo) => logo.id === imgId)?.logoColors?.length || 0;
  if(totalColor && totalColor > selected_color_count && !is_single_color_selected && selected_color_count !== 0) {
    isColorsValid = false;
  }
}

export function findLogoCordsHelper() {
  if (!qtyProxy?.canvasListForPosition) return;
  const rootElement = document.getElementById("jasani_product_builder");
  let productJson = rootElement?.getAttribute("data-products-json");
  const odooUrl = rootElement?.getAttribute("data-url");
  const isEdit = rootElement?.getAttribute("data-isEdit")?.toLocaleLowerCase() === "true";
  let haveDataInAllPosition = true;
  isColorsValid = true;

  const finalProductData = qtyProxy?.canvasListForPosition?.map((position, index) => {
    const url = DownloadImage(" ", "image", false, position?.canvas);
    const canvasObjects = position?.canvas?.getObjects();
    const overlayImgScaleX = Number(position?.canvas?.overlayImgScaleX ?? 1);
    const overlayImgScaleY = Number(position?.canvas?.overlayImgScaleY ?? 1);
    if(!canvasObjects){
      haveDataInAllPosition = false;
      return;
    }
    if (!productJson && position.selectedBrandingArea) return;
    const pxTommH = (px) => (position.selectedBrandingArea.detail_height * px) / position.selectedBrandingArea.height;
    const pxTommW = (px) => (position.selectedBrandingArea.detail_width * px) / position.selectedBrandingArea.width;

    const drawableArea = position?.drawableArea;

    let dataToSendOdoo = { imageObjects: [], textObjects: [], product_id: "", productImg: "", jsonForEdit: "", editLogoList: [] };
    dataToSendOdoo.productImg = url;

    dataToSendOdoo.jsonForEdit = position?.canvas?.toJSON(["id", "selectable","controlsVisibility","libraryId","overlayImgScaleY","overlayImgScaleX"]);
    dataToSendOdoo.editLogoList = qtyProxy?.logoList;
    
    dataToSendOdoo.imageObjects = canvasObjects
      ?.filter((obj) => obj.type === "image")
      .map((imgObj) => {
        const imageObject = qtyProxy?.logoList?.find((el) => el.id == imgObj.id);
        const logoWidthInCm = Math.ceil(pxTommW((imgObj.width * imgObj.scaleX)/overlayImgScaleX));
        const logoHeightInCm = Math.ceil(pxTommH((imgObj.height * imgObj.scaleY)/overlayImgScaleY));
        const logoFromLeftInCm = Math.ceil(pxTommW((imgObj.left - drawableArea.left)/overlayImgScaleX));
        const logoFromTopInCm = Math.ceil(pxTommH((imgObj.top - drawableArea.top)/overlayImgScaleY));
        const logoBase64Url = imgObj.toDataURL({
          format: "png",
          multiplier: 2,
        });

        colorValidationHandler(imgObj?.id,position?.selectedTechnique?.selected_color_count,position?.selectedTechnique.is_single_color_selected)

        return {
          id: imageObject?.id,
          fileName: imageObject?.imgName,
          imageUrl: logoBase64Url,
          logoWidth: logoWidthInCm,
          logoHeight: logoHeightInCm,
          logoFromTop: logoFromTopInCm,
          logoFromLeft: logoFromLeftInCm,
          logoRotation: imgObj?.angle,
          printAreaWidth: position.selectedBrandingArea.detail_width,
          printAreaHeight: position.selectedBrandingArea.detail_height,
          libraryId: imageObject?.libraryId
        };
      });
      
    dataToSendOdoo.textObjects = canvasObjects
      ?.filter((obj) => obj.type === "textbox")
      .map((textObj) => {
        const textWidthInMm = Math.ceil(pxTommW((textObj.width * textObj.scaleX)/overlayImgScaleX));
        const textHeightInMm = Math.ceil(pxTommH((textObj.height * textObj.scaleY)/overlayImgScaleY));
        const textFromLeftInMm = Math.ceil(pxTommW((textObj.left - drawableArea.left)/overlayImgScaleX));
        const textFromTopInMm = Math.ceil(pxTommH((textObj.top - drawableArea.top)/overlayImgScaleY));
        
        const svgOutput = createSvgFromText(textObj?.text, getSVGCords(textObj,overlayImgScaleX,overlayImgScaleY));

        return {
          fontSize: textObj?.fontSize,
          text: textObj?.text,
          fontWeight: textObj?.fontWeight,
          fontStyle: textObj?.fontStyle,
          underline: textObj?.underline,
          color: textObj?.fill,
          fontFamily: textObj?.fontFamily,
          textAlign: textObj?.textAlign,
          textWidth: textWidthInMm,
          textHeight: textHeightInMm,
          textFromTop: textFromTopInMm,
          textFromLeft: textFromLeftInMm,
          textRotation: textObj?.angle,
          printAreaWidth: position.selectedBrandingArea.detail_width,
          printAreaHeight: position.selectedBrandingArea.detail_height,
          textSVG: svgOutput
        };
      });

    if( dataToSendOdoo?.imageObjects?.length <= 0 &&  dataToSendOdoo?.textObjects?.length <= 0) {
      haveDataInAllPosition = false;
    }
    if(isEdit){
      return {...JSON.parse(qtyProxy?.['productEditData']),...dataToSendOdoo,...JSON.parse(productJson)[index] }
    }
    return { ...dataToSendOdoo, ...JSON.parse(productJson)[index] };
  });

  handleAddToCartApiCall(odooUrl,finalProductData,haveDataInAllPosition,isColorsValid);
}
